import { gql } from "@apollo/client";

const CONFIG_QUERY = {
	GET_ARCHIVE_CONFIG_VALUE: gql`
		{
			getOneConfig(configKey: "autoArchiveReportCount") {
				configValue
			}
		}
	`,
	UPDATE_ARCHIVE_CONFIG_VALUE: gql`
		mutation ($configValue: String!) {
			upsertConfig(
				configValue: $configValue
				configKey: "autoArchiveReportCount"
			) {
				configValue
				configKey
			}
		}
	`,
	GET_DISABLE_CONFIG_VALUE: gql`
		{
			getOneConfig(configKey: "autoDisableWarningCount") {
				configValue
			}
		}
	`,
	UPDATE_DISABLE_CONFIG_VALUE: gql`
		mutation ($configValue: String!) {
			upsertConfig(
				configValue: $configValue
				configKey: "autoDisableWarningCount"
			) {
				configValue
				configKey
			}
		}
	`,
	GET_USER_DISABLE_CONFIG_VALUE: gql`
		{
			getOneConfig(configKey: "autoDisableUserReportCount") {
				configValue
			}
		}
	`,
	UPDATE_USER_DISABLE_CONFIG_VALUE: gql`
		mutation ($configValue: String!) {
			upsertConfig(
				configValue: $configValue
				configKey: "autoDisableUserReportCount"
			) {
				configValue
				configKey
			}
		}
	`,

	GET_PROMO_LOVITZ_CONFIG: gql`
		{
			getLovitzConfig{
			 	count
				endTime
				status
			}
		}
	`,
	UPDATE_PROMO_LOVITZ_CONFIG: gql`
		mutation ($config: LovitzConfig) {
			lovitzConfigUpdate(
				config: $config
			) {
				count
				endTime
				status
			}
		}
	`,

};
export default CONFIG_QUERY;
